// extracted by mini-css-extract-plugin
export default {"footer":"NavbarFooter_footer__W3Eqa","dark":"NavbarFooter_dark__KTKQ2"};